import React from 'react'
import { useEffect, useState } from 'react'
import hero from '../../assets/chauffer/hero1.png'
import car from '../../assets/chauffer/carr.jpg'
import car1 from '../../assets/chauffer/car1.png'
import car2 from '../../assets/chauffer/car2.png'
import car3 from '../../assets/chauffer/car3.png'
import car4 from '../../assets/chauffer/car4.png'
import maruthi from '../../assets/chauffer/maruti.png'
import mini from '../../assets/chauffer/mini.png'
import benz from '../../assets/chauffer/car6.png'
import ChaufferAnimations from '../../../src/assets/animations/Loading Car Animation.json'
import { useNavigate } from 'react-router-dom'
import Loader from "../../components/common/Loader";

function Chauffersection() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true);

    const services = [
        {
            id: 1,
            title: "Airport Transfers / Pick Ups",
            description:
                "Effortless arrivals and departures from Mumbai and Pune airports. Our professional chauffeurs ensure timely pickups, luggage assistance, and a smooth ride to your destination—perfect for medical tourists, business travelers, and discerning guests.",
            image: car1,
        },
        {
            id: 2,
            title: "Corporate Travel",
            description:
                "Reliable, discreet service for day-long office runs, meeting drop-offs, and executive transport. Ideal for visiting professionals and business delegations.",
            image: car2,
        },
        {
            id: 3,
            title: "Special Events",
            description:
                "Add a touch of luxury to weddings, birthdays, and other celebrations, making them even more memorable.",
            image: car3,
        },
        {
            id: 4,
            title: "Self-Drive",
            description:
                "Prefer to drive yourself? Hire our Mini-Cooper S-Countryman (automatic) and explore at your own pace. Requirements: valid Indian/international driving license, government-issued photo ID, age 25+, and minimum 6 months driving experience.",
            image: car4,
        },
    ];

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {loading ? (
                <Loader animation={ChaufferAnimations} size={400} bgColor="gray-100" />
            ) : (
                <div>

                    {/* HERO SECTION */}
                    <section className="bg-[#F5E9D6] relative">
                        <div
                            className="flex items-center justify-center min-h-[50vh] sm:min-h-[60vh] md:min-h-[50vh] lg:min-h-[100vh] bg-cover bg-center relative "
                            style={{ backgroundImage: `url(${hero})` }}
                        >
                            <div className="absolute inset-0 bg-black/50"></div>
                            <div className='flex justify-center mt-10'>
                                <div className="flex flex-col items-center justify-center text-center relative z-10 px-4 ">
                                    <h1 className="animate-h font-['Playfair Display'] font-medium md:font-bold text-xl uppercase md:text-5xl lg:text-6xl text-white mb-4 tracking-wider ">
                                        Travel in Comfort & Style
                                    </h1>
                                    <h2 className="animate-h2 font-['Rufina'] font-light text-medium md:text-2xl text-[#F5F3F1] mb-12 max-w-3xl leading-relaxed">
                                        Premium Chauffeur & Self-Drive Services in Pune & Mumbai
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* ABOUT SECTION */}
                    <section className="bg-gradient-to-b from-[#F5E9D6] to-[#F5F3F1] py-16 px-6 md:px-12">
                        <div className="max-w-6xl mx-auto">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                                <div className="space-y-4">
                                    <p className="text-gray-800 font-[Rufina] text-base leading-relaxed">
                                        Travel In Comfort And Style With AJ Hospitality Chauffeur Services.
                                        Leave The Hassle Of Driving Behind And Let Us Take You Smoothly To
                                        Your Destination. Relax In Our Luxury Four-Seater Sedan Of Our Spacious
                                        SUV-Seater SUV. Both Designed For A Stress-Free Journey. The Chauffeur
                                        Service Only Operates In The Pune And Mumbai Areas Of Maharashtra.
                                    </p>
                                </div>
                                <div className="flex justify-center md:justify-end ">
                                    <img
                                        src={car}
                                        alt="Orange luxury sports car"
                                        className="w-full max-w-md h-auto rounded-tr-[60px] shadow-lg object-cove bg-[#E3E3E3]"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* WHY CHOOSE US */}
                    <section className="w-full bg-gradient-to-b from-[#F5F3F1] to-[#F5E9D6] py-4 md:py-4 px-4 sm:px-6 lg:px-8">
                        <div className="max-w-6xl mx-auto">
                            <div className="text-center mb-12">
                                <h2 className="text-2xl md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-4 font-['Rufina]">
                                    Why Choose Us
                                </h2>
                                <p className="text-[#181D24] md:text-base text-sm font-[Raleway] text-center max-w-2xl mx-auto leading-relaxed">
                                    Our chauffeurs are highly trained, experienced, and focused on safety and exceptional customer care.
                                </p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {services.map((service) => (
                                    <div
                                        key={service.id}
                                        className="bg-[#FFFFFF] rounded-tr-[30px] rounded-bl-[30px] overflow-hidden shadow-sm hover:shadow-md transition-shadow flex flex-col"
                                    >
                                        <div className="p-6 flex-grow">
                                            <h3 className="text-xl font-[550] font-[Raleway] mb-3">
                                                {service.title}
                                            </h3>
                                            <p className="text-[#1D221B] font-[Rufina] text-sm leading-relaxed mb-4">
                                                {service.description}
                                            </p>
                                        </div>
                                        <div className="relative h-56 overflow-hidden rounded-tr-[30px] rounded-bl-[30px] mx-4 mb-4 mt-auto">
                                            <img src={service.image} alt={service.title} className="w-full h-full object-cover" />
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className='flex items-center justify-center px-10 py-10'>
                                <button
                                    onClick={() => navigate('/chauffeur-booking')}
                                    className="animate-btn flex items-center gap-2 bg-[#5B656F] hover:bg-slate-600 text-white font-['Raleway'] py-2 px-6 md:py-2 md:px-6 rounded-lg duration-300 text-medium md:text-lg tracking-wide"
                                >
                                    Book Your Ride
                                </button>
                            </div>
                        </div>
                    </section>

                    {/* PRICING SECTION */}
                    <section className="px-4 py-4 bg-gradient-to-b from-[#F5E9D6] to-[#F5F3F1]">
                        <div className="max-w-6xl mx-auto mb-6">
                            <div className="text-center mb-12">
                                <h2 className="text-2xl md:text-4xl lg:text-5xl font-semibold md:font-semibold lg:font-normal text-[#181D24] mb-4 font-['Rufina']">
                                    Drive Your Way – Our Pricing
                                </h2>
                                <p className="text-[#181D24] md:text-base text-sm font-[Raleway] text-center max-w-2xl mx-auto leading-relaxed">
                                    Choose From Our Premium Rides With Clear, Upfront Pricing. Rates Are For 8 Hours;
                                    Additional Charges Apply Beyond The Limit.
                                </p>
                            </div>

                            {/* TWO SEPARATE CUSTOM CAR CARDS */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">

                                {/* Maruti XL6 Card */}
                                <div className="bg-white rounded-tr-[30px] rounded-bl-[30px] shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                                    <div className='px-4 py-4'>
                                        <div className="bg-[#E3E3E3] h-60 flex items-center justify-center overflow-hidden rounded-tr-[30px] rounded-bl-[30px]">
                                            <img src={maruthi} alt="Maruti XL6" className="w-full h-full object-cover mb-4" />
                                        </div>
                                    </div>
                                    <div className="px-4 mb-5">
                                        <h3 className="text-2xl font-semibold font-[Raleway] mb-2">Maruti XL6</h3>
                                        <div className="flex items-baseline gap-1 mb-4">
                                            <span className="text-2xl font-bold text-amber-600 font-[Rufina]">₹8800</span>
                                            <span className="text-xs font-[Rufina]">/8Hours</span>
                                            <span className="text-xs font-[Rufina]">(Within Pune City)</span>
                                        </div>
                                        <div className="h-px bg-gray-200 mb-4"></div>
                                        <ul className="space-y-2">
                                            <li className="flex items-center gap-2 text-sm font-[Rufina]">
                                                <span className="w-2 h-2 rounded-full bg-gradient-to-r from-[#2C3034] to-[#7D8C9A]"></span>
                                                4 Seater MPV
                                            </li>
                                            <li className="flex items-center gap-2 text-sm font-[Rufina]">
                                                <span className="w-2 h-2 rounded-full bg-gradient-to-r from-[#2C3034] to-[#7D8C9A]"></span>
                                                Including Chauffeur
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                {/* Toyota Hycross Card */}
                                <div className="bg-white rounded-tr-[30px] rounded-bl-[30px] shadow-md overflow-hidden hover:shadow-lg transition-shadow">
                                    <div className='px-4 py-4'>
                                        <div className="bg-[#E3E3E3] h-60 flex items-center justify-center overflow-hidden rounded-tr-[30px] rounded-bl-[30px]">
                                            <img src={benz} alt="Toyota Hycross" className="w-full h-full mt-3" />
                                        </div>
                                    </div>
                                    <div className="px-4 mb-5">
                                        <h3 className="text-2xl font-semibold font-[Raleway] mb-2">Toyota Hycross</h3>
                                        <div className="flex items-baseline gap-1 mb-4">
                                            <span className="text-2xl font-bold text-amber-600 font-[Rufina]">₹12500</span>
                                            <span className="text-xs font-[Rufina]">/8Hours</span>
                                            <span className="text-xs font-[Rufina]">(Within Pune City)</span>
                                        </div>
                                        <div className="h-px bg-gray-200 mb-4"></div>
                                        <ul className="space-y-2">
                                            <li className="flex items-center gap-2 text-sm font-[Rufina]">
                                                <span className="w-2 h-2 rounded-full bg-gradient-to-r from-[#2C3034] to-[#7D8C9A]"></span>
                                                4 Seater MPV
                                            </li>
                                            <li className="flex items-center gap-2 text-sm font-[Rufina]">
                                                <span className="w-2 h-2 rounded-full bg-gradient-to-r from-[#2C3034] to-[#7D8C9A]"></span>
                                                Including Chauffeur
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>

                </div>
            )}
        </>
    )
}

export default Chauffersection
